import React from '@wordpress/element';
import { createRoot } from 'react-dom/client';
import Accommodations from '../pages/accommodations';
import Experience from '../pages/experience';
import './view.scss';


const renderStaticParts = async () => {
    if (document.getElementById('accommodation-list-root')) {
        const accommodationListElement = document.getElementById('accommodation-list-root');
        const root = createRoot(accommodationListElement);
        root.render(<Accommodations />);
    }

    if (document.getElementById('experience-list-root')) {
        const experienceListElement = document.getElementById('experience-list-root');
        const root = createRoot(experienceListElement);
        root.render(<Experience />);
    }
};

renderStaticParts();